export const WIX_TERMS_AND_CONDITIONS_URL_ID =
  'digital-merchandising:websites-wix-terms-and-conditions';
export const WIX_PLANS_URL_ID = 'digital-merchandising:websites-wix-plans';
export const WIX_NEW_PLANS_URL_ID =
  'digital-merchandising:websites-wix-new-plans';
export const WIX_REDIRECT_URL_ID =
  'digital-merchandising:websites-wix-redirect';
export const WIX_SITE_SELECTOR_URL_ID =
  'digital-merchandising:websites-wix-site-selector';
export const WIX_ERROR_URL_ID = 'digital-merchandising:websites-wix-error';
export const WIX_BILLING_URL_ID =
  'digital-merchandising:websites-wix-initial-billing';
export const WEBS_SHUTDOWN_URL_ID = 'digital-merchandising:webs-shutdown';
export const WORKSPACE_URL_ID = 'workspace:website-dashboard';

export const SUBSCRIPTIONS_MANAGE_URL_ID = 'subscriptions:manage';
export const SUBSCRIPTIONS_CANCEL_URL_ID = 'subscriptions:cancel';
export const SUBSCRIPTIONS_CHANGE_PLAN_URL_ID = 'subscriptions:changePlan';
export const WIX_MFE_HOST = 'https://wix-mfe.digital.vpsvc.com';
export const DIWY_START = 'digital-merchandising:diwy-start-trial';
export const LOGO_MAKER = 'logoMaker';
export const WIX_DOMAINS_SEARCH_AND_SUGGESTIONS_URL_ID =
  'digital-merchandising:domains-wix-search-and-suggestions';
export const GOOGLE_WORKSPACE_URL_ID = 'vistaXWixGoogleWorkspace';
